export default "__VITE_ASSET__jaiDXJuq__"